var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2429_16155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2429_16155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 24,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3713 0L11.8472 2.13303V17.8316L23.3713 20.2873L34.9364 15.6576V3.94436L23.3713 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2429_16155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9364 0H11.8472V20.2873H34.9364V0Z",
    fill: "url(#paint0_linear_2429_16155)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8472 2.13307V17.8316L23.4933 20.2873V0.160889L11.8472 2.13307ZM16.7631 16.6237L13.4995 15.9803V3.90444L16.7631 3.38092V16.6237ZM21.84 17.5499L18.0923 16.9464V3.14014L21.84 2.49574V17.5499Z",
    fill: "#35276B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2429_16155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 24,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3149 0.201782L36.7908 2.33482V18.0323L48.3149 20.4881L59.84 15.8194V4.14615L48.3149 0.201782Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2429_16155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.84 0.201782H36.7908V20.4881H59.84V0.201782Z",
    fill: "url(#paint1_linear_2429_16155)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7908 2.33485V18.0324L48.3559 20.4881V0.362671L36.7908 2.33485ZM41.6667 16.8255L38.4031 16.1811V4.10522L41.6667 3.5817V16.8255ZM46.7446 17.7516L42.9969 17.1482V3.34092L46.7446 2.65656V17.7506V17.7516Z",
    fill: "#35276B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2429_16155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 21,
    width: 24,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5652 21.655L0.0400391 23.7891V39.4866L11.5652 41.9423L23.1303 37.3136V25.6004L11.5652 21.655Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2429_16155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1293 21.655H0.0400391V41.9423H23.1293V21.655Z",
    fill: "url(#paint2_linear_2429_16155)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.7891V39.3668L11.6451 41.8225V21.696L0 23.7891ZM4.87589 38.3197L1.6123 37.6354V25.5595L4.87589 24.996V38.3187V38.3197ZM9.99383 39.3668L6.24614 38.7633V24.7952L9.99383 24.1508V39.3658V39.3668Z",
    fill: "#35276B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2429_16155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 24,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4277 21.4941L24.9026 23.6282V39.3257L36.4277 41.8214L47.9528 37.1527V25.4395L36.4277 21.4941Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2429_16155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9518 21.4941H24.9026V41.8214H47.9518V21.4941Z",
    fill: "url(#paint3_linear_2429_16155)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9026 23.6273V39.3658L36.5077 41.8215V21.696L24.9026 23.6283V23.6273ZM29.7785 38.1579L26.5149 37.4735V25.3976L29.7785 24.8342V38.1579ZM34.8554 39.0431L31.1077 38.4396V24.6343L34.8554 23.9899V39.0441V39.0431Z",
    fill: "#35276B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2429_16155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 21,
    width: 24,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2902 21.696L49.7661 23.8291V39.5276L61.2902 41.9823L72.8553 37.3536V25.6404L61.2902 21.696Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2429_16155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.8563 21.696H49.7661V41.9823H72.8563V21.696Z",
    fill: "url(#paint4_linear_2429_16155)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7661 23.8291V39.3668L61.4112 41.8225V21.696L49.7661 23.8291ZM54.682 38.3597L51.4184 37.6753V25.5994L54.682 25.036V38.3597ZM59.7599 39.2449L56.0123 38.6414V24.8352L59.7599 24.1907V39.2449Z",
    fill: "#35276B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2429_16155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 43,
    width: 24,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0893 43.5529L11.5652 45.6459V61.3435L23.0893 63.8392L34.6544 59.1705V47.4972L23.0893 43.5529Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2429_16155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6554 43.5529H11.5652V63.8402H34.6554V43.5529Z",
    fill: "url(#paint5_linear_2429_16155)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5652 45.6459V61.3444L23.2103 63.8401V43.392L11.5652 45.6459ZM16.4811 60.1765L13.2175 59.4921V47.4163L16.4811 46.8528V60.1755V60.1765ZM21.558 61.1026L17.8103 60.4992V46.653L21.558 46.0086V61.1026Z",
    fill: "#35276B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2429_16155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 43,
    width: 24,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9929 43.7137L36.4678 45.8468V61.5453L47.9929 64L59.558 59.3713V47.6581L47.9929 43.7137Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2429_16155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.557 43.7137H36.4678V64.001H59.557V43.7137Z",
    fill: "url(#paint6_linear_2429_16155)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4678 45.8467V61.5452L48.1139 64.0009V43.8755L36.4678 45.8477V45.8467ZM41.3837 60.3773L38.1201 59.6929V47.617L41.3837 47.0536V60.3773ZM46.4606 61.2625L42.7129 60.659V46.8527L46.4606 46.2083V61.2625Z",
    fill: "#35276B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2429_16155",
    x1: 11.843,
    y1: 9.91036,
    x2: 34.9322,
    y2: 9.91036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2429_16155",
    x1: 36.7832,
    y1: 10.311,
    x2: 59.8324,
    y2: 10.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2429_16155",
    x1: 0.0324877,
    y1: 31.7662,
    x2: 23.0817,
    y2: 31.7662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2429_16155",
    x1: 24.896,
    y1: 31.6253,
    x2: 47.9453,
    y2: 31.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2429_16155",
    x1: 49.761,
    y1: 31.6074,
    x2: 72.8502,
    y2: 31.6074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2429_16155",
    x1: 11.561,
    y1: 53.4602,
    x2: 34.6503,
    y2: 53.4602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2429_16155",
    x1: 36.4636,
    y1: 53.6251,
    x2: 59.5529,
    y2: 53.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4998"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2429_16155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.8553,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAks);
export default __webpack_public_path__ + "static/media/aks.278f9916248af11a67aff2037e3fb15e.svg";
export { ForwardRef as ReactComponent };